import React, { useCallback } from 'react';
import { stringify } from 'querystring';
import { history, useIntl, useModel } from 'umi';
import {Avatar, Menu, message, Space, Spin} from 'antd';
import { KeyOutlined, LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';

import { outLogin } from '@/services/ant-design-pro/login';
import HeaderDropdown from '../HeaderDropdown';
import styles from './index.less';
import UpdateUserInfoModal from "@/components/RightContent/components/UpdateUserInfoModal";
import {ResetPwdParams} from "@/components/RightContent/data";
import {pwdChange} from "@/components/RightContent/service";

export type GlobalHeaderRightProps = {
  menu?: boolean;
  setPwdRestVisible?: (flag: boolean) => void;
  setUserUpdateVisible?: (flag: boolean) => void;
};

/**
 * 退出登录，并且将当前的 url 保存
 */
export const loginOut = async () => {
  await outLogin()
  // Note: There may be security issues, please note
  if (
    history.location.pathname.toLowerCase() !== '/user/login' &&
    !history.location.query?.redirect
  ) {
    localStorage.removeItem('Access-Token')
    history.replace({
      pathname: '/user/login',
      query: {
        redirect:
          history.location.pathname === '/noAccess'
            ? '/'
            : history.location.pathname + history.location.search,
      },
    })
  }
}

const defaultAvatarUrl = 'https://oss.lanxi.com/hm5_app/miniapp/default_doctor_avatar.png'

const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ menu, setPwdRestVisible, setUserUpdateVisible }) => {
  // 国际化
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  const t = window.$tc('component.RightContent.AvatarDropdown', intl.formatMessage);

  const { initialState, setInitialState } = useModel('@@initialState');
  const { setTabList, setCurrentTabIndex } = useModel('headerContentTabList');
// 重置密码
  const handleResetPwd = async (params: ResetPwdParams) => {
    const hide = message.loading(t('component.GlobalHeaderRight.index.t2', '正在设置'))
    try {
      const { code, msg } = await pwdChange({ ...params })
      hide()
      if (code === 200) {
        message.success(t('component.GlobalHeaderRight.index.t3', '设置成功'))
        return true
      }
      message.error(msg);
      return false
    } catch (error) {
      hide()
      message.error(t('component.GlobalHeaderRight.index.t4', '设置失败请重试！'))
      return false
    }
  }

  const onMenuClick = useCallback(
    (event: {
      key: React.Key;
      keyPath: React.Key[];
      item: React.ReactInstance;
      domEvent: React.MouseEvent<HTMLElement>;
    }) => {
      const { key } = event;
      if (key === 'logout' && initialState) {
        setInitialState({ ...initialState, currentUser: undefined, flatMenus: [], menus: [] });
        setTabList([]);
        setCurrentTabIndex(-1);
        loginOut();
        return;
      } else if (key === 'userUpdate' && initialState) {
        setUserUpdateVisible?.(true)
        return
      } else if (key === 'pwdRest' && initialState) {
        return
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [initialState, setInitialState],
  );

  const loading = (
    <span className={`${styles.action} ${styles.account}`}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  if (!currentUser || !currentUser.name) {
    return loading;
  }

  const menuHeaderDropdown = (
    <Menu className={styles.menu} selectedKeys={[]} onClick={onMenuClick}>
      {setUserUpdateVisible && (
        <Menu.Item key="userUpdate">
          <SettingOutlined />
          {t('t0', '编辑信息')}
        </Menu.Item>
      )}
      <UpdateUserInfoModal onSubmit={async(params)=>{
        const success = await handleResetPwd({
          account: initialState?.currentUser?.account,
          ...params
        })
        if (success) {

          loginOut();
          return true;
        }
        return false
      }}>
        <Menu.Item>
          <KeyOutlined />
          {t('t1', '修改密码')}
        </Menu.Item>
      </UpdateUserInfoModal>

      {(setUserUpdateVisible || setPwdRestVisible) && <Menu.Divider />}

      {menu && (
        <Menu.Item key="center">
          <UserOutlined />
          {t('t2', '个人中心')}
        </Menu.Item>
      )}
      {menu && (
        <Menu.Item key="settings">
          <SettingOutlined />
          {t('t3', '个人设置')}
        </Menu.Item>
      )}
      {menu && <Menu.Divider />}

      <Menu.Item key="logout">
        <LogoutOutlined />
        {t('t4', '退出登录')}
      </Menu.Item>
    </Menu>
  );
  return (
    <HeaderDropdown overlay={menuHeaderDropdown}>
      <span className={`${styles.action} ${styles.account}`}>
        <Avatar size="small" className={styles.avatar} src={currentUser.avatarUrl || defaultAvatarUrl} alt="avatar" />
        <span className={`${styles.name} anticon`}>{currentUser.name}</span>
      </span>
    </HeaderDropdown>
  );
};

export default AvatarDropdown;
